import * as actions from "actions/accessLevel";

export default (state = false, { type }) => {
  switch (type) {
    case actions.FETCH_ALL:
      return true;
    case actions.FETCH_ALL_FAILED:
    case actions.FETCH_ALL_SUCCESS:
      return false;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/accessLevel/isFetching.js